import { createContext } from "react";
const PageTitleContext = createContext({});
export default PageTitleContext;
